import { createReducer, on } from '@ngrx/store';
import * as fromSharedActions from '../actions/shared.action';

export const featureKey = 'shared';

export interface State {
  showLoading: boolean;
  dashboardWidgets: {
    data: Array<any>,
    isLoaded: Boolean
  },
  selectedRoom: any;
  selectedSubject: any;
  selectedProfessor: any;
}

export const initialState: State = {
  showLoading: false,
  dashboardWidgets: {
    data: [],
    isLoaded: false
  },
  selectedRoom: null,
  selectedSubject: null,
  selectedProfessor: null,
};

export const reducer = createReducer(
  initialState,
  on(fromSharedActions.setLoadingSpinner, (state: State, props: any) => ({
    ...state,
    showLoading: props.status,
  })),
  on(fromSharedActions.getDashboardWidgetsSuccess, (state: State, props: any) => ({
      ...state,
      dashboardWidgets: { data: props.data, isLoaded: true },
  })),
  on(fromSharedActions.selectRoom, (state: State, props: any) => ({
    ...state,
    selectedRoom: props.data,
  })),
  on(fromSharedActions.selectSubject, (state: State, props: any) => ({
    ...state,
    selectedSubject: props.data,
  })),
  on(fromSharedActions.selectProfessor, (state: State, props: any) => ({
    ...state,
    selectedProfessor: props.data,
  })),
);
